import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store';
import { logoutAction } from 'store/actions/auth-actions';
import { authStateSelector } from 'store/selectors/auth-selectors';
import OnboardingFlow from './OnboardingFlow';
import OnboardingPresentation from './OnboardingPresentation';
import { OnboardingContainer, OnboardingScrollableContainer } from './styles';

const Onboarding: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStateSelector);
  const [isFlowOpen, setIsFlowOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(logoutAction(false));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <OnboardingScrollableContainer>
      <OnboardingContainer>
        <OnboardingPresentation isFlowOpen={isFlowOpen} setIsFlowOpen={setIsFlowOpen} />
        <OnboardingFlow isInitiated={isFlowOpen} />
      </OnboardingContainer>
    </OnboardingScrollableContainer>
  );
};

export default Onboarding;
